module.exports = __webpack_public_path__ + "img/kangxin1.8c28a55b.png";